<template>
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.8574 14.4756H1.14258V12.9033H14.8574V14.4756ZM6.38965 8.38086L1.14258 11.7656V4.99512L6.38965 8.38086ZM14.8574 10.9375H7.23828V9.36426H14.8574V10.9375ZM14.8574 7.39746H7.23828V5.82422H14.8574V7.39746ZM14.8574 3.8584H1.14258V2.28613H14.8574V3.8584Z"
      fill="currentColor"
    />
  </svg>
</template>
